import { Module } from 'vuex';
import { RootState, ProductState } from './states';
import Product, { getProductsReq, putProduct, deleteProduct, Boat,
  createBoatReq, putBoatReq, deleteBoatReq, getBoatsReq, getProdInfoReq } from '@/api/product';
import { searchDeposits, DepositSearchResult, saveManualDeposit, deleteManualDeposit, listManualDeposits } from '@/api/stripe';

const productModule: Module<ProductState, RootState> = {
  namespaced: true,
  state: {
    productList: [],
    boatList: [],
  },
  getters: {
    products(state) {
      return state.productList;
    },
    boats(state) {
      return state.boatList;
    },
    boatByID: (state: ProductState) => (id: number) => {
      const idx = state.boatList.findIndex((b) => b.id === id);
      return idx === -1 ? null : state.boatList[idx];
    },
    productByID: (state: ProductState) => (id: number) => {
      const idx = state.productList.findIndex((p) => p.id === id);
      return idx === -1 ? null : state.productList[idx];
    },
  },
  mutations: {
    setBoats(state: ProductState, boats: Boat[]) {
      state.boatList = boats;
    },
    updateBoat(state: ProductState, boat) {
      const idx = state.boatList.findIndex((b) => b.id === boat.id);
      if (idx !== -1) {
        state.boatList.splice(idx, 1, boat);
      } else {
        state.boatList.push(boat);
      }
    },
    setProducts(state: ProductState, prods: Product[]) {
      state.productList = prods;
    },
    updateProd(state: ProductState, prod: Product) {
      const idx = state.productList.findIndex((p) => p.id === prod.id);
      if (idx !== -1) {
        state.productList.splice(idx, 1, prod);
      } else {
        state.productList.push(prod);
      }
    },
  },
  actions: {
    async saveProduct({dispatch}, prod: Product) {
      await dispatch('auth/makeAuthReq', putProduct(prod), { root: true });
      await dispatch('loadProducts');
    },
    async loadProducts({commit, dispatch}) {
      dispatch('tickets/loadCategories', null, {root: true });
      dispatch('loadBoats');
      const resp = await fetch(getProductsReq());
      commit('setProducts', await resp.json());
    },
    async deleteProduct({dispatch}, prod: Product) {
      await dispatch('auth/makeAuthReq', deleteProduct(prod), { root: true });
      await dispatch('loadProducts');
    },
    async loadBoats({commit}) {
      const resp = await fetch(getBoatsReq());
      commit('setBoats', await resp.json());
    },
    async createBoat({dispatch}, boat: Boat) {
      await dispatch('auth/makeAuthReq', createBoatReq(boat), { root: true });
      await dispatch('loadBoats');
    },
    async saveBoat({dispatch, commit}, boat: Boat) {
      await dispatch('auth/makeAuthReq', putBoatReq(boat), { root: true });
      await commit('updateBoat', boat);
    },
    async deleteBoat({dispatch}, boat: Boat) {
      await dispatch('auth/makeAuthReq', deleteBoatReq(boat), { root: true });
      await dispatch('loadBoats');
    },
    async getProdInfo({dispatch}, id: number): Promise<Product> {
      const resp = await dispatch('auth/makeAuthReq', getProdInfoReq(id), { root: true });
      return await resp.json();
    },
    async searchDeposits({}, yearmonth: string): Promise<DepositSearchResult[]> {
      const resp = await fetch(searchDeposits(yearmonth));
      return await resp.json();
    },
    async saveManualDeposit({dispatch}, req: any) {
      await dispatch('auth/makeAuthReq', saveManualDeposit(req), { root: true }); 
    },
    async deleteManualDeposit({dispatch}, req: any) {
      await dispatch('auth/makeAuthReq', deleteManualDeposit(req), { root: true });      
    },
    async listManualDeposits({}): Promise<any[]> {
      const resp = await fetch(listManualDeposits());
      return await resp.json();
    }
  },
};

export default productModule;
